import { animate, style, transition, trigger } from '@angular/animations';

export const TOGGLE_NAVIGATION = trigger('toggleNavigation', [
  transition(':enter', [
    style({ width: 0, opacity: 0 }),
    animate('0.2s ease-in-out', style({ width: '64px', opacity: 1 })) // 64px is the full bav bar width
  ]),
  transition(':leave', [
    animate('0.2s ease-in-out', style({ width: '0', opacity: 0 }))
  ])
]);